"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheCaymanWellnessPhilosophy() {
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="125475" id="our-care-philosophy" className="bg-background py-20 overflow-hidden !text-[hsl(223,23%,43%)] lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imgRef} className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:max-w-none rounded-2xl overflow-hidden shadow-2xl">
              <img src="https://fair-mollusk.10web.cloud/wp-content/uploads/2026/04/physician-photo2-scaled.jpg" alt="Crescent Direct Primary Care Physician" className="object-cover w-full h-full" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent mix-blend-multiply"></div>
            </div>
            {}
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-accent/30 rounded-full -z-10 blur-3xl"></div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-10 transition-all duration-1000 delay-200 ease-out ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="space-y-6">
              <h2 className="text-4xl font-serif leading-tight tracking-tight !text-[hsl(223,23%,43%)] md:text-5xl lg:text-6xl">
                A Return to <span className="italic !text-[hsl(223,23%,43%)]">Continuity</span> and <span className="italic !text-[hsl(223,23%,43%)]">Community</span>
              </h2>
              
              <div className="w-12 h-1 bg-secondary/40 rounded-full"></div>
              
              <p className="text-lg leading-relaxed font-sans font-light !text-[hsl(223,23%,43%)] md:text-xl">
                At Crescent Direct Primary Care, our philosophy is rooted in the belief that healthcare is most effective when it is personal, transparent, and unhurried.
              </p>
              
              <p className="text-lg text-muted-foreground leading-relaxed font-sans">We take a patient-centered approach to family medicine, committed to promoting long-term health through a direct primary care model. True wellness is built on a foundation of trust and accessibility, ensuring you receive comprehensive care that is tailored to your family's unique needs.</p>
            </div>

            <div className="pt-8 border-t border-border/60">
              {}
              <svg className="h-16 w-auto text-secondary/60 mb-6" viewBox="0 0 250 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M15 55 C 30 20, 50 15, 65 45 C 80 75, 100 60, 110 40 C 120 20, 140 15, 150 35 C 160 55, 180 65, 190 45 C 200 25, 220 15, 230 35 C 240 55, 250 50, 245 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M85 25 C 95 15, 105 15, 115 25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              
              <div className="space-y-1">
                <h3 className="text-xl font-serif font-semibold !text-[hsl(223,23%,43%)]">Elvira Jasarevic, D.O.</h3>
                <p className="text-sm font-medium !text-[hsl(223,23%,43%)]">Board Certified Family Physician</p>
                
              </div>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base h-12 bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
                <Link to="/MembershipPage">
                  Learn About Our Model
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}